export const FEATURE_NAME = "activity";
